import { render, staticRenderFns } from "./AppOrderSelector.vue?vue&type=template&id=3c4840b5&scoped=true"
import script from "./AppOrderSelector.vue?vue&type=script&lang=ts"
export * from "./AppOrderSelector.vue?vue&type=script&lang=ts"
import style0 from "./AppOrderSelector.vue?vue&type=style&index=0&id=3c4840b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4840b5",
  null
  
)

export default component.exports